import { api } from '../api/api'

/**
 * El `sign_out` es cortesía hacia el servidor, no un requisito para cerrar
 * sesión localmente. Un kiosko sin red no puede quedarse colgado en el logout,
 * y axios no impone timeout por defecto.
 */
export const SIGN_OUT_TIMEOUT_MS = 3000

/**
 * Libera el `client_id` de la sesión actual en el servidor (`users.tokens`).
 * Debe llamarse ANTES de limpiar los tokens locales: el DELETE se autentica con
 * ellos. Best-effort: nunca lanza, para que el logout local siempre continúe.
 *
 * Vive fuera de `api.js` a propósito: así los tests que mockean `../api/api`
 * siguen interceptando `api.delete('/auth/sign_out', { timeout })`.
 */
export async function revokeSessionOnServer() {
  try {
    await api.delete('/auth/sign_out', { timeout: SIGN_OUT_TIMEOUT_MS })
  } catch (err) {
    console.warn('[logout] Could not revoke the session server-side:', err?.message)
  }
}
